import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { OBSIDIAN } from 'HubStyleTokens/colors';
const PageHeader = styled.div.withConfig({
  displayName: "SplashPageHeader__PageHeader",
  componentId: "sc-1wsgce8-0"
})(["margin:auto;"]);
const PageTitle = styled.h1.withConfig({
  displayName: "SplashPageHeader__PageTitle",
  componentId: "sc-1wsgce8-1"
})(["text-align:center;font-size:32px;font-weight:900;margin-bottom:16px;line-height:40px;"]);
const SubTitle = styled.p.withConfig({
  displayName: "SplashPageHeader__SubTitle",
  componentId: "sc-1wsgce8-2"
})(["text-align:center;font-size:14px;color:", ";margin-bottom:0;"], OBSIDIAN);

const SplashPageHeader = ({
  titleKey,
  subtitleKey
}) => {
  const title = titleKey || 'splash-page.header.title';
  const subtitle = subtitleKey || 'splash-page.header.subtitle';
  return /*#__PURE__*/_jsxs(PageHeader, {
    children: [/*#__PURE__*/_jsx(PageTitle, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: title
      })
    }), /*#__PURE__*/_jsx(SubTitle, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: subtitle
      })
    })]
  });
};

export default SplashPageHeader;